import script from "./CommercialView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommercialView.vue?vue&type=script&setup=true&lang=js"

import "./CommercialView.vue?vue&type=style&index=0&id=213b58a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213b58a5"]])

export default __exports__